export default "__VITE_ASSET__CbNGI4t6__"